/* Zenmen header behaviour: Shop mega menu + mobile menu.
   One copy, binding to every .zh-header on the page, so the homepage header and
   the sitewide chrome header behave identically. They used to be two scripts
   with two class prefixes, and they had drifted — the chrome saved and restored
   the document's inline overflow around the mobile menu while the homepage
   clobbered it, so opening and closing the homepage menu wiped any overflow a
   another component had set.

   Each header finds its own mega and mobile menus through aria-controls rather
   than a document-wide query, so two headers on one page never cross-wire. */
(function () {
  if (window.__zenHeaderInit) return;
  window.__zenHeaderInit = true;

  function byControls(el) {
    var id = el && el.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function wire(header) {
    if (header.__zenWired) return;
    header.__zenWired = true;

    /* --- Shop mega menu --- */
    var shop = header.querySelector('.zh-nav-shop');
    var mega = byControls(shop) || header.querySelector('.zh-mega');
    var caret = header.querySelector('.zh-nav-caret');

    var setMega = function (open) {
      if (!mega) return;
      mega.hidden = !open;
      if (shop) shop.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (caret) caret.textContent = open ? '▲' : '▼';
    };

    if (shop && mega) {
      shop.addEventListener('mouseenter', function () { setMega(true); });
      shop.addEventListener('focus', function () { setMega(true); });
      shop.addEventListener('click', function (e) { e.preventDefault(); setMega(mega.hidden); });
      Array.prototype.forEach.call(
        header.querySelectorAll('.zh-nav-link:not(.zh-nav-shop), .zh-iconbtn'),
        function (el) { el.addEventListener('mouseenter', function () { setMega(false); }); }
      );
      header.addEventListener('mouseleave', function () { setMega(false); });
      header.addEventListener('focusout', function (e) {
        if (!header.contains(e.relatedTarget)) setMega(false);
      });
      document.addEventListener('click', function (e) {
        if (!mega.hidden && !header.contains(e.target)) setMega(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !mega.hidden) { setMega(false); shop.focus(); }
      });
    }

    /* --- Mobile menu --- */
    var toggle = header.querySelector('.zh-navtoggle');
    var mob = byControls(toggle);
    if (!toggle || !mob) return;

    var prevOverflow = '';
    var isOpen = function () { return !mob.hidden; };
    var setMob = function (open) {
      if (open === isOpen()) return;
      mob.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* Save and restore rather than clobbering: another component may already
         have set an inline overflow on <html>. */
      if (open) {
        prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = prevOverflow;
      }
    };

    toggle.addEventListener('click', function () {
      if (mega && !mega.hidden) setMega(false);
      setMob(!isOpen());
    });
    var closeBtn = mob.querySelector('.zh-mobmenu-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { setMob(false); toggle.focus(); });
    }
    mob.addEventListener('click', function (e) { if (e.target === mob) setMob(false); });
    Array.prototype.forEach.call(mob.querySelectorAll('a'), function (link) {
      link.addEventListener('click', function () { setMob(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { setMob(false); toggle.focus(); }
    });
    window.addEventListener('resize', function () {
      if (isOpen() && window.innerWidth > 989) setMob(false);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.zh-header'), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* The theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
